(function () {
	const slideshow = () => {
		document.querySelectorAll(".slideshow").forEach((slideshowBlock) => {
			const box = slideshowBlock.closest("section");

			if (!box) return;

			const id = box.getAttribute("id");
			const block = $(slideshowBlock);

			const autoplay = block.data("autoplay");
			const stopAutoplay = block.data("stop-autoplay");
			const delay = Number(block.data("delay")) * 1000;
			const speed = Number(block.data("speed")) * 1000;
			const effect = block.data("effect");

			const swiperTextSelector = `#${id} .slideshow__tabs-wrapper`;
			const swiperTextElement = document.querySelector(swiperTextSelector);

			const swiperImgSelector = `#${id} .slideshow__contents-wrapper`;
			const swiperImgElement = document.querySelector(swiperImgSelector);

			if (!swiperTextElement || !swiperImgElement) return;

			const isTwoColumns = swiperImgElement.classList.contains("slideshow--two-columns");

			const swiperParams = {
				speed: speed,
				keyboard: true,
				loop: !isTwoColumns
			};

			const autoplayParams = autoplay && !isTwoColumns ? {
				autoplay: {
					delay: delay,
					disableOnInteraction: false,
					pauseOnMouseEnter: stopAutoplay
				}
			} : {};

			const swiperText = new Swiper(swiperTextSelector, {
				...swiperParams,
				spaceBetween: 24,
				direction: "horizontal",
				slidesPerView: "auto",
				allowTouchMove: false,
				breakpoints: {
					990: {
						allowTouchMove: true
					},
					1600: {
						allowTouchMove: false,
						touchRatio: 0,
						keyboard: {
							enabled: false
						}
					}
				},
				on: {
					init: function () {
						swiperTextElement.classList.add("first_step");
					},
					slideChange: function () {
						swiperTextElement.classList.remove("first_step");
					}
				}
			});

			const swiperImg = new Swiper(swiperImgSelector, {
				...swiperParams,
				...autoplayParams,
				effect: isTwoColumns ? "slide" : effect,
				slidesPerView: isTwoColumns ? 2 : 1,
				spaceBetween: isTwoColumns ? 0 : 0,
				allowTouchMove: !isTwoColumns,
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true
				},
				thumbs: isTwoColumns ? undefined : {
					swiper: swiperText
				},
				breakpoints: {
					0: {
						slidesPerView: 1
					},
					750: {
						slidesPerView: isTwoColumns ? 2 : 1
					}
				},
				on: {
					init: function () {
						swiperImgElement.classList.add("first_step");
						box.style.setProperty("--bullet-duration", `${delay}ms`);
					},
					slideChange: function () {
						box.style.setProperty("--bullet-duration", `${delay + speed}ms`);
					},
					slideChangeTransitionEnd: function () {
						swiperImgElement.classList.remove("first_step");
					}
				}
			});

			if (autoplay && stopAutoplay && !isTwoColumns) {
				swiperImgElement.addEventListener("mouseenter", function () {
					swiperTextElement.classList.add("stop_move");
				});

				swiperImgElement.addEventListener("mouseleave", function () {
					swiperTextElement.classList.remove("stop_move");
				});
			}

			if (block.find(".slideshow__content").length === 1) {
				swiperImgElement.classList.add("no_slideshow");
				swiperTextElement.classList.add("no_slideshow");

				swiperImg.destroy(true, true);
				swiperText.destroy(true, true);
			}
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		slideshow();

		document.addEventListener("shopify:section:load", function () {
			slideshow();
		});
	});
})();